import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alarm-add",
  templateUrl: "./med-icon-alarm-add.component.html",
})
export class MedIconAlarmAddComponent extends SvgMixinComponent {}
